import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import { styles } from '../../styles';

const DialogAppContent = ({ children, classes }) => {
  return (
    <DialogContent className={classes.dialogContent}>
      {children}
    </DialogContent>
  );
};

export default withStyles(styles)(DialogAppContent);



// WEBPACK FOOTER //
// ./src/components/DialogApp/components/DialogAppContent/DialogAppContent.jsx